import React, { useState, useEffect } from "react";

const PoModal = ({ showPoModal, handlePoClose, poDataList, onRowSelectPo }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredPoDataList, setFilteredPoDataList] = useState([]);
  const [selectedPoList, setSelectedPoList] = useState([]);

  // อัปเดตเมื่อ `poDataList` หรือ `searchTerm` เปลี่ยนแปลง
  useEffect(() => {
    setFilteredPoDataList(
      poDataList.filter(
        (po) =>
          po.Doc_No.toLowerCase().includes(searchTerm.toLowerCase()) ||
          po.AP_Name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, poDataList]);

  // รีเซ็ตค่าทุกครั้งที่เปิด Modal
  useEffect(() => {
    if (showPoModal) {
      setSearchTerm("");
      setSelectedPoList([]);
    }
  }, [showPoModal]);

  // ฟังก์ชันสำหรับเลือก/ยกเลิกรายการ
  const handleSelectPo = (po) => {
    setSelectedPoList((prevSelected) => {
      const isSelected = prevSelected.some(
        (selected) => selected.Doc_No === po.Doc_No
      );
      return isSelected
        ? prevSelected.filter((selected) => selected.Doc_No !== po.Doc_No) // เอาออกถ้ามีอยู่แล้ว
        : [...prevSelected, po]; // เพิ่มเข้าไปถ้ายังไม่มี
    });
  };

  // ฟังก์ชันยืนยันการเลือก PO หลายรายการ
  const handleConfirmSelection = () => {
    onRowSelectPo(selectedPoList);
    handlePoClose();
  };

  return (
    <>
      <div
        className={`modal ${showPoModal ? "show" : ""}`}
        style={{ display: showPoModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">เลือกใบสั่งซื้อ (PO)</h5>
              <button type="button" className="close" onClick={handlePoClose}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="ค้นหาเลขที่เอกสาร (PO) หรือ ชื่อผู้ขาย"
                  value={searchTerm || ""}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div
                className="table-responsive"
                style={{ maxHeight: "600px", overflowY: "auto" }}
              >
                <table className="table table-striped table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th className="text-center" style={{ width: "5%" }}>
                        เลือก
                      </th>
                      <th className="text-center" style={{ width: "15%" }}>
                        เลขที่เอกสาร (PO)
                      </th>
                      <th className="text-center" style={{ width: "40%" }}>
                        ชื่อผู้ขาย
                      </th>
                      <th className="text-center" style={{ width: "35%" }}>
                        รายละเอียดเอกสาร
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPoDataList && filteredPoDataList.length > 0 ? (
                      filteredPoDataList.map((po, index) => (
                        <tr key={po.Doc_Id || index + 1}>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={selectedPoList.some(
                                (selected) => selected.Doc_No === po.Doc_No
                              )}
                              onChange={() => handleSelectPo(po)}
                            />
                          </td>
                          <td className="text-center">{po.Doc_No}</td>
                          <td className="text-left">{po.AP_Name}</td>
                          <td
                            style={{
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                              whiteSpace: "pre-wrap",
                              maxWidth: "200px",
                            }}
                          >
                            {po.Doc_Remark1}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10">
                          <center>
                            <h5>ไม่พบข้อมูล</h5>
                          </center>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handlePoClose}>
                ปิด
              </button>
              <button
                className="btn btn-primary"
                onClick={handleConfirmSelection}
                disabled={selectedPoList.length === 0}
              >
                ยืนยัน ({selectedPoList.length})
              </button>
            </div>
          </div>
        </div>
      </div>

      {showPoModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default PoModal;
